import { Component } from 'react';
import { connect } from 'react-redux'
import AuthActions from '../../store/authRedux'
import auth from '../../services/auth/AuthProvider';

class AuthTimers extends Component {
    constructor(props) {
        super(props)

        this.checkForTokenRefresh = this.checkForSilentLogin.bind(this)

        this.state = {
            signedIn: this.props.signedIn,
            lang: this.props.lang
        }

        this.tokenRefreshInterval = null
    }

    componentWillReceiveProps(newProps) {
        if (this.state.signedIn !== newProps.signedIn) {
            if (newProps.signedIn) {
                this.startTokenRefreshInterval(true)
            } else {
                this.clearTokenRefreshInterval()
            }
            this.setState({ signedIn: newProps.signedIn })
        }
    }

    componentDidMount() {
        this.startTokenRefreshInterval(this.state.signedIn)
    }

    startTokenRefreshInterval(signedIn) {
        this.clearTokenRefreshInterval(); 
        if (signedIn) {
            this.tokenRefreshInterval = setInterval(this.checkForTokenRefresh, 4 * 60 * 1000)
        }
    }

    clearTokenRefreshInterval() {
        if (this.tokenRefreshInterval) {
            clearInterval(this.tokenRefreshInterval)
            this.tokenRefreshInterval = null
        }
    }

    componentWillUnmount() {
        this.clearTokenRefreshInterval()
    }

    checkForSilentLogin() {
        if (!auth.isAuthenticated()) {
            this.clearTokenRefreshInterval();
        } else {
            var lang = this.state.lang
            var timetolive = (auth.getTokenTimeToLive() / 1000) / 60            
            if (timetolive < 10) {
                auth.silentAuthentication(() => {
                    return {
                        language: lang
                    }
                });
            }
        }
    }

    render() {
        return null
    }
}


const mapStateToProps = (state) => {
    return {
        signedIn: state.auth.signedIn,
        lang: state.layout.lang
    }
}

export default connect(mapStateToProps)(AuthTimers)